import React from 'react';
import {
  Box,
  Container,
  HStack,
  Text,
  Link
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <Box 
      bg="var(--gris-bleute)" 
      borderTop="1px solid"
      borderColor="rgba(139, 148, 179, 0.2)"
      py={3}
      px={4}
      mt="auto"
    >
      <Container maxW="container.xl">
        <HStack 
          justify="center" 
          spacing={4} 
          wrap="wrap"
          fontSize="xs"
        >
          <Text color="var(--texte-secondaire)" fontWeight="medium">
            © 2025 QuizVS
          </Text>
          
          <Text color="rgba(139, 148, 179, 0.5)">•</Text>
          
          <Link 
            as={RouterLink}
            to="/terms"
            color="var(--bleu-electrique)"
            _hover={{ 
              textDecoration: 'underline',
              color: "var(--magenta-vif)"
            }}
            fontSize="xs"
          >
            {t('footer.terms')}
          </Link>
          
          <Link 
            as={RouterLink}
            to="/privacy"
            color="var(--bleu-electrique)"
            _hover={{ 
              textDecoration: 'underline',
              color: "var(--magenta-vif)"
            }}
            fontSize="xs"
          >
            {t('footer.privacy')}
          </Link>
          
          <Text color="rgba(139, 148, 179, 0.5)">•</Text>
          
          <Text color="var(--texte-secondaire)" fontSize="xs">
            contact@quizvs.com
          </Text>
        </HStack>
      </Container>
    </Box>
  );
};

export default Footer;
